import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from '../context/api';

const departments = ['Teaching', 'Human Resources', 'Finance', 'Administration'];
const roles = ['Teacher', 'Service Worker', 'Bursar', 'Headmaster', 'Groundsman', 'Other'];

const EditEmployee = () => {
  const { employeeId } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState({
    Department: '',
    Role: '',
    Name: '',
    Surname: '',
    DateOfBirth: '',
    Address: '',
    PhoneNumber: '',
    NationalIDNumber: '',
    Gender: '',
    EmployeeNumber: '',
    Password: ''
  });

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/createemployee/${employeeId}`);
        // Convert the DateOfBirth to a format suitable for the input field
        const data = response.data;
        data.DateOfBirth = new Date(data.DateOfBirth).toISOString().split('T')[0];
        setEmployee(data);
      } catch (error) {
        console.error('Error fetching employee:', error);
      }
    };
    fetchEmployee();
  }, [employeeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee((prevEmployee) => ({
      ...prevEmployee,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${BASE_URL}/createemployee/${employeeId}`, employee);
      if (response.status === 200) {
        toast.success('Employee updated successfully');
        setTimeout(() => {
          navigate('/employees');
        }, 2000);
      }
    } catch (error) {
      toast.error('Error updating employee');
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Edit Employee</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block">Department</label>
          <select
            name="Department"
            value={employee.Department}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          >
            <option value="" disabled>Select Department</option>
            {departments.map((dept) => (
              <option key={dept} value={dept}>{dept}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block">Role</label>
          <select
            name="Role"
            value={employee.Role}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          >
            <option value="" disabled>Select Role</option>
            {roles.map((role) => (
              <option key={role} value={role}>{role}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block">Name</label>
          <input
            type="text"
            name="Name"
            value={employee.Name}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block">Surname</label>
          <input
            type="text"
            name="Surname"
            value={employee.Surname}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block">Date of Birth</label>
          <input
            type="date"
            name="DateOfBirth"
            value={employee.DateOfBirth}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block">Address</label>
          <input
            type="text"
            name="Address"
            value={employee.Address}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block">Phone Number</label>
          <input
            type="text"
            name="PhoneNumber"
            value={employee.PhoneNumber}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block">National ID Number</label>
          <input
            type="text"
            name="NationalIDNumber"
            value={employee.NationalIDNumber}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <div>
          <label className="block">Gender</label>
          <select
            name="Gender"
            value={employee.Gender}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          >
            <option value="" disabled>Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        <div>
          <label className="block">Employee Number</label>
          <input
            type="text"
            name="EmployeeNumber"
            value={employee.EmployeeNumber}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
            readOnly
          />
        </div>
        <div>
          <label className="block">Password</label>
          <input
            type="text"
            name="Password"
            value={employee.Password}
            onChange={handleChange}
            className="p-2 border rounded w-full"
            required
          />
        </div>
        <button
          type="submit"
          className="p-2 bg-blue-500 text-white rounded"
        >
          Update Employee
        </button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default EditEmployee;
